/**
 * @generated SignedSource<<db0660b39dd67ffc2fee34f516e1163b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreatorsTopCreators_viewer$data = {
  readonly topCreators: {
    readonly creators: ReadonlyArray<{
      readonly url: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"CreatorsTopCreator_topCreator">;
    } | null> | null;
    readonly title: string | null;
  } | null;
  readonly " $fragmentType": "CreatorsTopCreators_viewer";
};
export type CreatorsTopCreators_viewer$key = {
  readonly " $data"?: CreatorsTopCreators_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CreatorsTopCreators_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "vertical"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreatorsTopCreators_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "vertical",
          "variableName": "vertical"
        }
      ],
      "concreteType": "TopCreatorsList",
      "kind": "LinkedField",
      "name": "topCreators",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TopCreator",
          "kind": "LinkedField",
          "name": "creators",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "CreatorsTopCreator_topCreator"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "62fa873fa5f2f73134d66b6624f46735";

export default node;
